import { useEffect, useState } from "react";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";
import { Building2, Save, ImagePlus, X } from "lucide-react";

export function CompanySettings() {
  const [form, setForm] = useState({ name: "", address: "", phone: "", email: "", logo: "", logo_width: 120, logo_align: "left" });
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/company").then((r) => setForm({ logo: "", logo_width: 120, logo_align: "left", ...r.data })).catch(() => {}); }, []);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onLogo = (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (f.size > 500 * 1024) { toast.error("Logo 500KB'dan küçük olmalı"); return; }
    const r = new FileReader();
    r.onload = () => set("logo", r.result);
    r.readAsDataURL(f);
  };

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings/company", form);
      const fav = document.getElementById("app-favicon");
      if (fav) fav.href = `/api/settings/favicon?v=${Date.now()}`;
      const touch = document.getElementById("app-touch-icon");
      if (touch) touch.href = `/api/settings/app-icon/180.png?v=${Date.now()}`;
      toast.success("Firma bilgileri kaydedildi");
    }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  const ic = "min-h-[44px] w-full rounded-xl border border-border bg-white px-3.5 py-2.5 text-sm outline-none focus:border-primary";
  const lc = "mb-1 block text-xs font-semibold text-muted-foreground";
  return (
    <div data-testid="company-settings" className="max-w-xl rounded-2xl border border-border bg-white p-5 shadow-sm">
      <div className="mb-1 flex items-center gap-2"><Building2 className="h-5 w-5 text-primary" /><h3 className="font-display text-lg font-bold">Gönderen Firma Bilgileri</h3></div>
      <p className="mb-4 text-sm text-muted-foreground">Bu bilgiler sevk formunun üst kısmında görünür. Logo, formun başlığına eklenir.</p>

      <div className="mb-4">
        <label className={lc}>Logo</label>
        <div className="flex items-center gap-3">
          <div className="flex h-20 w-20 items-center justify-center overflow-hidden rounded-xl border border-border bg-secondary/40">
            {form.logo ? <img src={form.logo} alt="logo" className="max-h-full max-w-full object-contain" data-testid="company-logo-preview" /> : <ImagePlus className="h-6 w-6 text-muted-foreground" />}
          </div>
          <div className="flex flex-col gap-2">
            <label data-testid="company-logo-upload" className="inline-flex cursor-pointer items-center gap-1.5 rounded-lg border border-border px-3 py-2 text-sm font-medium hover:bg-secondary">
              <ImagePlus className="h-4 w-4" /> Logo Yükle
              <input type="file" accept="image/*" onChange={onLogo} className="hidden" />
            </label>
            {form.logo && (
              <button data-testid="company-logo-remove" onClick={() => set("logo", "")} className="inline-flex items-center gap-1.5 rounded-lg border border-rose-300 px-3 py-2 text-xs font-medium text-rose-600 hover:bg-rose-50">
                <X className="h-3.5 w-3.5" /> Kaldır
              </button>
            )}
          </div>
        </div>
        <p className="mt-1 text-xs text-muted-foreground">PNG/JPG, en fazla 500KB.</p>
        {form.logo && (
          <div className="mt-3 grid grid-cols-2 gap-3">
            <div>
              <label className={lc}>Logo Genişliği: {form.logo_width}px</label>
              <input data-testid="company-logo-width" type="range" min="60" max="300" step="5" value={form.logo_width} onChange={(e) => set("logo_width", Number(e.target.value))} className="w-full accent-primary" />
            </div>
            <div>
              <label className={lc}>Hizalama</label>
              <select data-testid="company-logo-align" value={form.logo_align} onChange={(e) => set("logo_align", e.target.value)} className={ic}>
                <option value="left">Sola</option>
                <option value="center">Ortaya</option>
                <option value="right">Sağa</option>
              </select>
            </div>
          </div>
        )}
      </div>

      <div className="space-y-3">
        <div><label className={lc}>Firma Adı *</label><input data-testid="company-name" className={ic} value={form.name} onChange={(e) => set("name", e.target.value)} /></div>
        <div><label className={lc}>Adres</label><textarea data-testid="company-address" rows={2} className={ic} value={form.address} onChange={(e) => set("address", e.target.value)} /></div>
        <div><label className={lc}>Telefon</label><input data-testid="company-phone" className={ic} value={form.phone} onChange={(e) => set("phone", e.target.value)} /></div>
        <div><label className={lc}>E-posta</label><input data-testid="company-email" className={ic} value={form.email} onChange={(e) => set("email", e.target.value)} /></div>
      </div>
      <button data-testid="company-save-btn" onClick={save} disabled={saving} className="mt-4 inline-flex min-h-[44px] items-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-semibold text-white hover:brightness-110 disabled:opacity-50"><Save className="h-4 w-4" /> {saving ? "Kaydediliyor..." : "Kaydet"}</button>
    </div>
  );
}
